module.exports = __webpack_public_path__ + "static/media/dkj.b3191b6c.svg";